import { parseDateOnlyParts } from '@erp/shared-utils';

/** `YYYY-MM-DD` to `MM-DD` without going through a Date (no timezone shift). */
export function oldestSoLabel(value: string | null): string | null {
  if (value === null) return null;
  const parts = parseDateOnlyParts(value);
  if (parts === null) return null;
  return `${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
}
